import api from 'api';

export const mutateRoute = async ({ data, id }) => {
  const endpoint = `/routes${id ? `/${id}` : ''}`;

  return api()[id ? 'put' : 'post'](endpoint, data);
};
